import { createFeatureSelector, createSelector } from '@ngrx/store';

import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';

import { ModuleConfiguration } from '../../vocabulary.module.config';
import { CodeSystemVersionListModel } from '../../models/CodeSystemVersionListModel';
import { CodeSystemVersionDashboardModel } from '../../models/CodeSystemVersionDashboardModel';
import { vocabularyReducer } from './Vocabulary.reducer';
import { ValueSetModel } from '../../models/ValueSetModel';
import { ValueSetListModel } from '../../models/ValueSetListModel';
import { ConceptWorkspaceModel } from "../../models/ConceptWorkspaceModel";
import * as actions from '../../../pillar/dashboard/store/actions/';

export interface VocabularyState {
  codeSystemDashboardState: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>;
  valueSetDashboardState: TileState<ValueSetModel, ValueSetModel>;
  conceptWorkspaceState: TileState<ConceptWorkspaceModel, ConceptWorkspaceModel>;
};

let valueSetDashboardStateReducer;
export function valueSetDashboardStateReducerWrapper (state = new TileState<ValueSetModel, ValueSetModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!valueSetDashboardStateReducer){
    valueSetDashboardStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, ValueSetModel, ValueSetModel, new TileState<ValueSetModel, ValueSetModel>());
  }
  return valueSetDashboardStateReducer(state, action);
}

let conceptWorkspaceStateReducer;
export function conceptWorkspaceStateReducerWrapper (state = new TileState<ConceptWorkspaceModel, ConceptWorkspaceModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!conceptWorkspaceStateReducer){
    conceptWorkspaceStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, ConceptWorkspaceModel, ConceptWorkspaceModel, new TileState<ConceptWorkspaceModel, ConceptWorkspaceModel>());
  }
  return conceptWorkspaceStateReducer(state, action);
}

export const reducers = {
  codeSystemDashboardState: vocabularyReducer,
  valueSetDashboardState: valueSetDashboardStateReducerWrapper,
  conceptWorkspaceState: conceptWorkspaceStateReducerWrapper
};

export const getVocabularyState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getCodeSystemDashboardState = createSelector(getVocabularyState, (s: VocabularyState) => s.codeSystemDashboardState);

export const getCodeSystemVersionList = createSelector(getCodeSystemDashboardState, (s: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>) => s.list);
export const getCodeSystemVersionListTotalCount = createSelector(getCodeSystemDashboardState, (s: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>) => s.totalCount);
export const getCodeSystemVersionListLoading = createSelector(getCodeSystemDashboardState, (s: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>) => s.loading);
export const getCodeSystemVersionListErrors = createSelector(getCodeSystemDashboardState, (s: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>) => s.errors);
export const getCodeSystemVersionSelection = createSelector(getCodeSystemDashboardState, (s: TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>) => s.selected);

export const getvalueSetDashboardState = createSelector(getVocabularyState, (s: VocabularyState) => s.valueSetDashboardState);
export const getConceptsForValueSetList = createSelector(getvalueSetDashboardState, (s: TileState<ValueSetModel, ValueSetModel>) => s.list);
export const getConceptsForValueSetListTotalCount = createSelector(getvalueSetDashboardState, (s: TileState<ValueSetModel, ValueSetModel>) => s.totalCount);
export const getConceptsForValueSetListLoading = createSelector(getvalueSetDashboardState, (s: TileState<ValueSetModel, ValueSetModel>) => s.loading);
export const getConceptsForValueSetListErrors = createSelector(getvalueSetDashboardState, (s: TileState<ValueSetModel, ValueSetModel>) => s.errors);

export const getConceptWorkspaceState = createSelector(getVocabularyState, (s: VocabularyState) => s.conceptWorkspaceState);
export const getConceptSelection = createSelector(getConceptWorkspaceState, (s: TileState<ConceptWorkspaceModel, ConceptWorkspaceModel>) => s.selected);





// WEBPACK FOOTER //
// ./src/app/vocabulary/store/reducers/index.ts